'use client';

import { FC, PropsWithChildren } from 'react';
import { ROOT_PORTALS } from 'constants/targets';
import { Portal, Drawer } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';

export const DeleteEquipmentDrawerWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const { deleteEquipmentDrawer: { drawerProps, isChild } } = useMyEquipmentDrawer();
  const deleteEquipmentDrawerProps = {
    ...drawerProps,
    disableBackdropClick: isChild,
    hideCloseButton: isChild,
  };

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer {...deleteEquipmentDrawerProps}>{children}</Drawer>
    </Portal>
  );
};
